export default "__VITE_ASSET__CrxmIRbj__"